import { Col, Row, Space, Spin, Tag, Timeline, Typography } from 'antd';
import { useGetHistoryByInvoiceIdQuery } from 'api/invoice';
import dayjs from 'dayjs';
import React, { FC } from 'react';
import { IInvoiceHistoryProps } from 'types/feature/invoice.types';

import {
  computeInvoiceStatusLabel,
  computeTagColor,
} from '../InvoiceStatusSwitch/helpers/helper';
import './invoice-history.styles.scss';

const { Text } = Typography;

const InvoiceHistory: FC<IInvoiceHistoryProps> = ({ invoiceId }) => {
  const { data: historyData, isLoading } =
    useGetHistoryByInvoiceIdQuery(invoiceId);
  return (
    <>
      {isLoading ? (
        <Spin className="center" />
      ) : (
        <Timeline
          className="history-timeline"
          items={historyData?.data.invoiceHistory.map((item) => {
            return {
              children: (
                <Row justify="space-between">
                  <Col>
                    <Space direction="vertical">
                      <Text>{item.createdBy.fullname} set the status to</Text>
                      <Tag
                        className="status-history-tag"
                        color={computeTagColor(item.status)}
                      >
                        {computeInvoiceStatusLabel(item.status)}
                      </Tag>
                    </Space>
                  </Col>
                  <Col>
                    {dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                  </Col>
                </Row>
              ),
            };
          })}
        />
      )}
    </>
  );
};

export default InvoiceHistory;
